import { useContext } from 'react';

import { AppContext } from '../../AppContext';
import { Config } from '../../config';
import { mergeUrlParameters } from '../../helpers/uri';
import { ShopifyContext } from '../ShopifyProvider';

const useCheckoutUrl = (): URL => {
  const { userLocation, getCurrentUrl, currentLocale, cookieManager } = useContext(AppContext);
  const { cart, store } = useContext(ShopifyContext);
  const { options } = Config.shopify ?? {};
  const gaCookie = cookieManager.getCookie('_ga');
  let queryParams: Record<string, string | boolean> = {
    'attributes[locale]': currentLocale,
    locale: currentLocale,
    'checkout[shipping_address][country]': userLocation.country,
    access_token: store?.storefrontAccessToken ?? '',
  };

  // Cart keys are now variant IDs (e.g. "gid://shopify/ProductVariant/12345")
  const productsInCart = Object.keys(cart?.lineItems ?? {})
    .map(variantId => {
      const numericId = variantId.match(/\/(\d+)/);

      if (numericId) {
        return `${numericId[1]}:${cart.lineItems[variantId]}`;
      }

      return '';
    })
    .filter(Boolean)
    .join(',');

  if (options?.checkoutQueryParams) {
    queryParams = {
      ...queryParams,
      ...options.checkoutQueryParams,
    };
  }

  if (gaCookie) {
    queryParams._ga = gaCookie;
  }

  const queryString = Object.entries(queryParams)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  const shopifyUrl = new URL(`https://${store?.domain}/cart/${productsInCart}?${queryString}`);
  mergeUrlParameters(shopifyUrl, new URL(getCurrentUrl()), Config.persistentQueryParams);
  return shopifyUrl;
};

export { useCheckoutUrl };
